import { cn } from '../utils/cn';

export function Skeleton({
  width,
  height = 12,
  className,
  rounded = 'md',
}: {
  width?: number | string;
  height?: number | string;
  className?: string;
  rounded?: 'sm' | 'md' | 'lg' | 'full';
}) {
  return (
    <span
      style={{ width, height }}
      className={cn(
        'inline-block animate-pulse bg-[var(--color-bg-card-hover)]',
        rounded === 'full' ? 'rounded-full' : `rounded-${rounded}`,
        className
      )}
    />
  );
}

export default Skeleton;
